var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "info-circle",
    d: "M16,9.032A6.968,6.968,0,1,1,9.032,16,6.969,6.969,0,0,1,16,9.032M16,8a8,8,0,1,0,8,8A8,8,0,0,0,16,8ZM14.839,19.1h.387V15.226h-.387a.387.387,0,0,1-.387-.387v-.258a.387.387,0,0,1,.387-.387h1.548a.387.387,0,0,1,.387.387V19.1h.387a.387.387,0,0,1,.387.387v.258a.387.387,0,0,1-.387.387H14.839a.387.387,0,0,1-.387-.387v-.258A.387.387,0,0,1,14.839,19.1ZM16,11.355a1.032,1.032,0,1,0,1.032,1.032A1.032,1.032,0,0,0,16,11.355Z",
    transform: "translate(-8 -8)",
    fill: "#535353"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info-circle.d9900b9aa95bb1542aac6678578cbeb7.svg";